module.exports = __webpack_public_path__ + "4750edc0a9bd000e23fd761f05c66e6b.png";